import { useLocation, useNavigate } from "react-router-dom";
import { Box, Paper, Typography, Button } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import btnStyles from '../styles/buttons.module.scss';
export default function ApplicationSuccess() {

    const navigate = useNavigate();
    const location = useLocation();

    // data passed from navigate(state)
    const applicationId = location.state?.applicationId;

    return (

        <Box
            sx={{
                minHeight: "70vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                px: 2
            }}
        >

            <Paper
                elevation={4}
                sx={{
                    maxWidth: 1200,
                    width: "100%",
                    p: 5,
                    textAlign: "center",
                    borderRadius: 3
                }}
            >

                {/* Icon */}
                <CheckCircleIcon
                    sx={{
                        fontSize: 70,
                        color: "#2e7d32",
                        mb: 2
                    }}
                />

                {/* Title */}
                <Typography variant="h4" fontWeight={700} gutterBottom sx={{textAlign: "center"}}>
                    Application Submitted
                </Typography>

                {/* Message */}
                <Typography variant="body1" sx={{ textAlign: "center", mb: 3 }}>
                    Thank you for your application.
                    We have successfully received your submission.
                </Typography>

                {/* Buttons */}
                <Box
                    sx={{
                        display: "flex",
                        gap: 2,
                        justifyContent: "center",
                        flexWrap: "wrap"
                    }}
                >

                    <Button
                        className={btnStyles.btnDesktop}
                        variant="contained"
                        size="large"
                        sx={{ textTransform: 'none' }}
                        onClick={() => navigate("/")}
                    >
                        Return to Home
                    </Button>

                </Box>

            </Paper>

        </Box>

    );

}